import styled from 'styled-components'

export const NavigationDropDownComponent = styled.div`
  .navigation-tabs-topic__nav {
    display: block;
    position: relative;
    margin-bottom: 10px;

    ul {
      padding: 0;
    }

    .navigation-tabs-topic__toggle {
      margin: 0;

      li {
        display: block;
        margin: 0;
        position: relative;
        width: 100%;

        &:nth-of-type(n + 1) {
          margin-top: 10px;
        }

        a {
          display: flex;
          align-items: center;
          border-right: 6px solid #008a34;
          padding: 0 16px;

          width: 100%;
          background: #ffffff;
          color: #303030;
          text-decoration: none;
          height: 80px;
          box-shadow: 1px 2px 1px 0 rgb(0 0 0 / 13%);

          &[role='button'] {
            position: relative;

            &:not(.locked):before {
              color: #008a34;
              line-height: 25px;
              position: absolute;
              top: 50%;
              right: 16px;
              display: inline-block;
              font: normal normal normal 18px 'aok-icons-functional';
              line-height: 1;
              text-rendering: auto;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
              transform: translateY(-50%);
              content: '';
              vertical-align: middle;
            }
          }
        }

        span {
          display: block;
          font-size: 20px;
        }
      }
    }

    .navigation-tabs-topic__list {
      margin: 0;
      width: 100%;

      li {
        display: block;
        margin: 0;
        position: relative;
        width: 100%;

        &:nth-of-type(n + 1) {
          margin-top: 10px;
        }

        a {
          display: flex;
          align-items: center;
          border-right: 6px solid #008a34;
          padding: 0 16px;

          width: 100%;
          background: #ffffff;
          color: #303030;
          text-decoration: none;
          height: 80px;
          box-shadow: 1px 2px 1px 0 rgb(0 0 0 / 13%);
        }

        &.active a {
          background-color: #ffffff;
          border-color: #6b6b6b;
          cursor: default;

          &:after {
            content: '';
            width: 10px;
            height: 20px;
            display: block;
            border-right: 10px solid #6b6b6b;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            position: absolute;
            right: 6px;
            top: 30px;
          }
        }

        span {
          display: block;
          font-size: 20px;
          margin-left: 16px;
        }
      }
    }
  }
`
